/**
 * Injects argument-service into the scope of your class
 * Will only work on service instances that are in the provider tree of your class (Avoid duplicating provider declarations)
 * ONLY USE AS A LAST RESORT, IF YOU CANNOT REFACTOR CODE
 * Use case:
 * svcA <=> svcB (circular dep)
 * Solution:
 * * step 0:
 * * svcA public | private [nameInScope]<svcB>;
 * * step 1:
 * * svcA extends CircularDepCrutch
 * * step 2:
 * * svcB constructor => svcA.addService<svcB>(path, this) - this will add "svcB" into "svcA" as 'this[path]'
 * *
 * **/
export class CircularDepCrutch {
  addService<T>(path: string, svc: T): void {
    if (path) {
      path.split('.').reduce((that, key, i, arr) => {
        if (!that[key]) {
          Object.assign(that, {[key]: {}});
        }

        if (i + 1 === arr.length) {
          that[key] = svc;
        } else {
          return that[key];
        }
      }, this);
    }
  }
}
